import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const DetailsLoadingTranslationsPageProvider = createTranslationsPageProvider({
  prime: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-prime/translations/${brand}/${locale}/flights_waiting_pax-page.js`),
  flightResults: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "[request]" */`@edreamsodigeo/frontend-flights-results/translations/${brand}/${locale}/details_loading.js`)
});